import { config } from '../../../../config';

export const commissionTypeOptions = [
  { value: 2, text: 'Percentage (%)' },
  { value: 1, text: 'Fixed Amount (AED)' },
];

export const entitySourcesOptions = [
  'ASSETS_BRANCH',
  'DXB_BRANCH',
  'AUH_BRANCH',
];
export const envOptions = ['staging', 'development', 'qa'];
export const notAllowedEnvs = ['STAGING_BRANCH', 'QA_BRANCH', 'DEV_BRANCH'];

export const SORT_FIELDS = [
  { key: 'SharedDate', label: 'Shared Date' },
  { key: 'EntityName', label: 'Entity Name' },
  { key: 'Language', label: 'Language' },
  { key: 'Nationality', label: 'Nationality' },
  { key: 'Community', label: 'Community' },
  { key: 'City', label: 'City' },
  { key: 'District', label: 'District' },
  { key: 'ContactName', label: 'Contact Name' },
];

export const claimTypeEnums = {
  NormalClaim: 1,
  ReassignClaim: 2,
  SendToRotationClaim: 3,
};
